import { creatorQueryKeys as e } from "./useCreatorQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { creatorApi as n } from "@maat/api-main";
//#region src/creator/useCreatorLinkTimeseriesQuery.ts
var r = (r, i) => t({
	queryKey: e.linkTimeseries(r, i),
	queryFn: () => n.linkTimeseries(r, i),
	enabled: !!r
});
//#endregion
export { r as useCreatorLinkTimeseriesQuery };
